import { render, staticRenderFns } from "./manage-web-info.vue?vue&type=template&id=6bfd1e2a&"
import script from "./manage-web-info.vue?vue&type=script&lang=js&"
export * from "./manage-web-info.vue?vue&type=script&lang=js&"
import style0 from "./manage-web-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports